<script setup>
import { computed } from 'vue';
import BaseIcon from '@/components/Base/BaseIcon.vue';
import BaseTooltip from '@/components/Base/BaseTooltip.vue';
import { opportunityLabelContext } from '@/composables/useOpportunityLabel';

const props = defineProps({
  segment: {
    type: Object,
    required: true,
  },
});

const context = computed(
  () => opportunityLabelContext[props.segment.opportunity.value]
);

const segmentText = computed(() =>
  [
    props.segment.role,
    props.segment.primary_skill,
    props.segment.second_primary_skill,
    props.segment.region,
  ]
    .filter(Boolean)
    .join(' · ')
);
</script>

<template>
  <div
    v-if="context"
    class="cursor-pointer flex items-center justify-center"
  >
    <BaseIcon
      :name="context?.icon"
      :class="context?.iconClass"
      size="14px"
    />
    <BaseTooltip :offset="[0, 6]">
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-1">
          <span
            class="text-[10px] font-semibold uppercase tracking-wide text-proxify-gray-500"
          >
            Segment
          </span>
          <span class="text-body-xs font-medium text-proxify-gray-700">
            {{ segmentText }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <div
            class="w-[18px] h-[18px] rounded-full flex items-center justify-center shrink-0"
          >
            <BaseIcon
              :name="context?.icon"
              :class="context?.iconClass"
              size="10px"
            />
          </div>
          <span
            class="text-body-xs font-semibold"
            :class="context?.textClass"
          >
            {{ segment.opportunity.label }}
          </span>
        </div>
        <p
          v-if="segment.summary"
          class="text-body-xs font-medium text-proxify-gray-600"
        >
          {{ segment.summary }}
        </p>
      </div>
    </BaseTooltip>
  </div>
</template>
